<template>
  <div class="container-fluid">
    <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body px-3 pt-0 pb-2 min-vh-50">
              <form id="search" class="mt-3" @submit.prevent="getDelivery">
                <div class="row g-2 d-flex justify-content-end">
                  <div class="col-12 col-sm-3">
                    <label class="text-xxs font-weight-normal text-secondary" for="name">Month</label>
                    <Datepicker 
                      v-model="search.month" 
                      range
                      monthPicker
                      format="MMMM yyyy"
                      placeholder="Select month"
                      />
                  </div>
                  <div class="col-12 col-sm-2 align-self-top pt-4 d-flex">
                    <button type="submit" class="btn btn-primary mb-0 justify-content-center" style="width: 50px;" @click="resetOffset">
                      <i class="fa fa-search"></i>
                    </button>

                    <!-- Adding margin to create space -->
                    <button class="btn btn-primary mb-0 justify-content-center" style="width: 50px; margin-left: 5px;" @click="clearSearch">
                      <i class="fa fa-times-circle"></i>
                    </button>

                  </div>
                </div>
              </form>
              <hr class="my-2"/>
              <div class="d-flex justify-content-end">
                <!-- <button class="btn btn-xs btn-outline-primary"><i class="fa fa-download"></i> Download</button> -->
                <div class="d-flex">
                  <p class="align-self-center text-xs text-secondary">{{ current_page }} - {{ current_total_data }} / {{ total_data }}</p>
                  <argon-pagination color="gradient-primary" size="sm">
                    <argon-pagination-item
                      @click="prevPage"
                      prev
                      :disabled="offset === 0 ? true : false" />
                    <argon-pagination-item
                      @click="nextPage"
                      next
                      :disabled="record_more === false ? true : false" />
                  </argon-pagination>
                </div>
              </div>
              <div class="table-responsive">
                <table class="table align-items-center">
                    <thead>
                      <tr class="bg-light">
                        <th class="text-uppercase text-xxs font-weight-bolder ps-2">#</th>
                        <th class="text-uppercase text-xxs font-weight-bolder ps-2">Month</th>
                        <th class="text-uppercase text-xxs font-weight-bolder ps-2">Year</th>
                        <th class="text-uppercase text-xxs font-weight-bolder ps-2">State</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="line in deliveries" :key="line.id">
                        <td>
                          <router-link :to="'/delivery/' + line.id" class="text-xs text-primary font-weight-bold mb-0">
                              {{ line.name }}
                          </router-link>
                        </td>
                        <td>
                          <p class="mb-0 text-sm">{{ line.month }}</p>
                        </td>
                        <td>
                          <p class="mb-0 text-sm">{{ line.year }}</p>
                        </td>
                        <td>
                          <argon-badge color="info" size="sm">{{ line.state }}</argon-badge>
                        </td>
                      </tr>
                    </tbody>
                </table>
              </div>
              <!-- <div class="table-responsive">
                <table class="table table-bordered align-items-center">
                    <thead>
                        <tr class="">
                            <th rowspan="2" class="text-center text-uppercase text-xxs font-weight-bolder pt-3"><input type="checkbox" class="mb-0"/></th>
                            <th rowspan="2" class="text-uppercase text-xxs font-weight-bolder ps-2">DN Number</th>
                            <th colspan="4" class="text-center text-uppercase text-xxs font-weight-bolder ps-2">Order</th>
                            <th colspan="5" class="text-center text-uppercase text-xxs font-weight-bolder ps-2">Delivery</th>
                        </tr>
                        <tr class="">
                            <th class="text-uppercase text-xxs font-weight-bolder ps-2">Date</th>
                            <th class="text-uppercase text-xxs font-weight-bolder ps-2">Lane No</th>
                            <th class="text-uppercase text-xxs font-weight-bolder ps-2">Delivery / Day</th>
                            <th class="text-uppercase text-xxs font-weight-bolder ps-2">Category</th>
                            <th class="text-uppercase text-xxs font-weight-bolder ps-2">Shop</th>
                            <th class="text-uppercase text-xxs font-weight-bolder ps-2">Date</th>
                            <th class="text-uppercase text-xxs font-weight-bolder ps-2">Cycle</th>
                            <th class="text-uppercase text-xxs font-weight-bolder ps-2">Plant Site</th>
                            <th class="text-uppercase text-xxs font-weight-bolder ps-2">Parking No.</th>
                        </tr>
                    </thead>
                  <tbody>
                    <tr v-for="(delivery, i) in deliveries" :key="i">
                      <td class="text-center w-5">
                        <input type="checkbox" class="mb-0"/>
                      </td>
                      <td>
                        <router-link :to="'/delivery/' + delivery.id" class="text-xs text-primary font-weight-bold mb-0">
                            {{ delivery.dn_no }}
                        </router-link>
                      </td>
                      <td>
                        <p class="mb-0 text-xs">{{ delivery.order.date }}</p>
                      </td>
                      <td>
                        <p class="mb-0 text-xs">{{ delivery.order.lane_no }}</p>
                      </td>
                      <td>
                        <p class="mb-0 text-xs">{{ delivery.order.delivery_per_day }}</p>
                      </td>
                      <td>
                        <p class="mb-0 text-xs">{{ delivery.order.category }}</p>
                      </td>
                      <td>
                        <p class="mb-0 text-xs">{{ delivery.delivery.shop }}</p>
                      </td>
                      <td>
                        <p class="mb-0 text-xs">{{ delivery.delivery.date }}</p>
                      </td>
                      <td>
                        <p class="mb-0 text-xs">{{ delivery.delivery.cycle }}</p>
                      </td>
                      <td>
                        <p class="mb-0 text-xs">{{ delivery.delivery.plant_site }}</p>
                      </td>
                      <td>
                        <p class="mb-0 text-xs">{{ delivery.delivery.parking_no }}</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div> -->
              <empty-state v-if="!deliveries.length > 0 && !loading"/>
              <loading-state v-if="loading == true"/>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import ArgonBadge from "@/components/ArgonBadge.vue";
import ArgonPagination from "@/components/ArgonPagination.vue";
import ArgonPaginationItem from "@/components/ArgonPaginationItem.vue";
import EmptyState from "./components/EmptyState.vue";
import LoadingState from "./components/LoadingState.vue";
const endpoint = require("../router/endpoint");
export default {
  name: "delivery",
  components: {
    ArgonBadge,
    ArgonPagination,
    ArgonPaginationItem,
    EmptyState,
    LoadingState
  },
  data() {
    return {
      loading: false,
      total_data: 0,
      current_total_data: 0,
      record_more: false,
      page: 0,
      current_page: 0,
      offset: 0,
      search: {
        month: null
      },
      deliveries: [],
    };
  },
  methods: {
    prevPage() {
      if (this.offset > 0) {
          this.offset = this.offset - 10
          this.getDelivery()
        }
    },
    nextPage() {
      if (this.record_more === true) {
        this.offset = this.offset + 10
        this.getDelivery()
      }
    },
    getDate(daterange) {
      var dateList = []
      if (daterange !== null){
        if (daterange.length > 0) {
          daterange.forEach(date => {
            if (date !== null) {
              let month = date.month >= 9 ? (date.month + 1) : '0' + (date.month + 1)
              let fullDate = date.year + '-' + month + '-' + '01'
              dateList.push(fullDate)
            }
          });
        }
      }
      return dateList
    },
    getDelivery() {
      this.loading = true
      this.deliveries = []
      this.total_data = 0
      this.current_total_data = 0
      this.record_more = false
      this.current_page = 0
      const getMonthrange = this.getDate(this.search.month)
      const values = {
        date_start: getMonthrange.length > 0 ? getMonthrange[0] : null,
        date_end: getMonthrange.length > 1 ? getMonthrange[1] : null,
        partner_id: localStorage.getItem("partner_id"),
        limit: 10,
        offset: this.offset
      }
      this.axios
        .post(
          endpoint.DELIVERY_LIST,
          values,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`
            }
          }
        )
        .then((response) => {
          if (response.data.response_code === "0000") {
            this.deliveries = response.data.data;
            this.total_data = response.data.total_data
            this.current_total_data = response.data.current_total_data
            this.record_more = response.data.record_more
            this.current_page = response.data.current_page
          } else {
            if (response.data.response_code !== "4000"){
              this.$notify({
                type: 'warn',
                title: 'Warning',
                text: response.data.message,
              });
            }
          }
          this.loading = false
        })
        .catch((e) => {
          this.loading = false;
          this.$notify({
              type: 'error',
              title: 'Something went wrong!',
              text: e.response.data.message,
            });
        });
    },
    clearSearch(){
          this.search.month = null;
    }
  },
  mounted() {
    this.getDelivery()
  }
};
</script>

<style>

</style>